import React from 'react';

import Icon from './Icon';

export const Tick = ({className}) => {
  return (
    <Icon className={className}>
      <svg width="32" height="32" viewBox="0 0 32 32">
        <path d="M29.4904764,2.93769249 L10.6090937,22.3454158 C9.97348282,23.0277186 8.8892054,23.0277186 8.2535945,22.3454158 L0.476708176,14.2714996 C-0.158902725,13.5891969 -0.158902725,12.527837 0.476708176,11.8455342 C1.11231908,11.1632315 2.1965965,11.1632315 2.8322074,11.8455342 L9.45003855,18.7064677 L27.172366,0.511727079 C27.8079769,-0.170575693 28.8922544,-0.170575693 29.5278653,0.511727079 C30.1634762,1.19402985 30.1634762,2.25538972 29.4904764,2.93769249 Z" transform="translate(1 5)"/>
      </svg>

    </Icon>
  );
};